import { HttpClient } from '@angular/common/http';
import { Injectable, inject, DestroyRef } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { message } from 'pi-api';
import { IMessage, IMessagesListFiltersInterface } from '@data/schema';
import { takeUntilDestroyedSafe } from '../helpers/take-until-destroyed-safe';

@Injectable()
export class MessagesListService {
  private readonly destroyRef = inject(DestroyRef);

  private readonly httpClient = inject(HttpClient);

  public lastListResponse!: any;

  protected readonly _counter$: BehaviorSubject<number[]> = new BehaviorSubject([0, 0]);

  get counters$() {
    return this._counter$.asObservable();
  }

  getMessages(filters?: IMessagesListFiltersInterface): Observable<IMessage[]> {
    return this.httpClient
      .post<any>(message.postGetMessages(), {
        culture: 'pl-PL',
        ...(filters || {}),
      })
      .pipe(
        map((rs) => {
          this._counter$.next([rs.countNew, rs.count]);
          return rs.items;
        })
      );
  }

  setMessageAsRead(id: number): Observable<IMessage> {
    return this.httpClient.patch<IMessage>(message.patchMessagesRead(id), {});
  }

  postNewMessage(rq: any): Observable<IMessage> {
    return this.httpClient
      .post<any>(message.postMessages(), rq)
      .pipe(takeUntilDestroyedSafe(this.destroyRef));
  }

  deleteMessage(ids: number[]): Observable<IMessage> {
    return this.httpClient
      .delete<any>(message.deleteMessages(), { body: ids })
  }
}
